import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Typography, Box } from "@mui/material";
import axios from "axios";
import { CONNECT_WITH_US } from "../../api/connectwithus";

const MarkoknowConnectDataGrid = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(CONNECT_WITH_US);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "fullName", headerName: "Full Name", width: 200 },
    { field: "organization", headerName: "Organization", width: 200 },
    { field: "designation", headerName: "Designation", width: 200 },
    { field: "email", headerName: "Email ID", width: 250 },
    { field: "phone", headerName: "Phone Number", width: 150 },
    { field: "purpose", headerName: "Purpose", width: 250 },
  ];

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Markoknow Connect With Us
      </Typography>
      <DataGrid
        rows={data.map((item, index) => ({ ...item, id: index + 1 }))}
        columns={columns}
        pageSize={10}
        loading={loading}
        autoHeight
      />
    </Box>
  );
};

export default MarkoknowConnectDataGrid;